export const COMMUNICATE_WITH_CONSUMER_MODAL_NAME = 'communicateWithConsumer';
